document.addEventListener('DOMContentLoaded', () => {
  const details = document.querySelector('.custom-tabs-dropdown');
  const nav = details?.querySelector('nav');

  // ==========================================
  // 1. LOGICA MOBILE ORIGINALE (Intatta)
  // ==========================================
  if (details && nav) {
    function toggleScroll(open) {
      document.body.style.overflow = open ? 'hidden' : '';
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }

    details.addEventListener('click', (e) => {
      const isSummary = e.target.closest('summary');
      if (!isSummary) return;

      if (details.open) {
        e.preventDefault();
        nav.style.maxHeight = nav.scrollHeight + 'px';
        requestAnimationFrame(() => {
          nav.style.maxHeight = '0';
          nav.style.opacity = '0';
          nav.style.transform = 'translateY(-8px)';
        });
        setTimeout(() => {
          details.removeAttribute('open');
          toggleScroll(false);
        }, 750);
      }
    });

    details.addEventListener('toggle', () => {
      if (details.open) {
        nav.style.maxHeight = nav.scrollHeight + 'px';
        nav.style.opacity = '1';
        nav.style.transform = 'translateY(0)';
        toggleScroll(true);
      } else {
        toggleScroll(false);
      }
    });
  }
// ==========================================
  // NUOVA LOGICA DESKTOP (PURO CSS, ZERO LAG)
  // ==========================================
  const desktopWrapper = document.getElementById('desktop-tabs-wrapper');
  const desktopToggle = document.getElementById('desktop-toggle-btn');
  const desktopArrow = document.getElementById('desktop-arrow');

  if (desktopWrapper && desktopToggle) {
    desktopToggle.addEventListener('click', () => {
      // Aggiunge o toglie la classe che attiva il CSS
      desktopWrapper.classList.toggle('is-closed');
      
      // Ruota la freccia fluidamente
      if (desktopArrow) {
        if (desktopWrapper.classList.contains('is-closed')) {
          desktopArrow.style.transform = 'rotate(0deg)';
        } else {
          desktopArrow.style.transform = 'rotate(180deg)';
        }
      }
    });
  }
});